import type { FC } from 'react';
import React from 'react';
import { Text } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import styled from 'styled-components';
import { messages } from '../../../i18n/messages';

const MyAudiCtaDisclaimer: FC = () => {
  return (
    <CustomText variant={{ order: '2', style: 'normal', type: 'copy' }}>
      {useI18n(messages.myAudiLegalDisclaimer)}
    </CustomText>
  );
};

export default MyAudiCtaDisclaimer;

const CustomText = styled(Text)`
  padding: 10px 0;
`;
